module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/pxiEyp8kv8JHgFVrJJnecnFHGPezSQ.4d1490f3.woff2";